<script>
import _ from 'lodash/core'
import isMobile from 'ismobilejs'
import PhotoSwipe from 'photoswipe'
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'
import ScrollMagic from 'scrollmagic'


import GalleryImage from './gallery/GalleryImage'

export default {
  components: {
    GalleryImage
  },
  props: {
    id: {type: Number, default: 1}
  },
  data () {
    return {
      pswpElement: document.querySelector('.pswp'),
      gallery: null
    }
  },
  computed: {
    items () {
      let items = [];
      for (var i = 0; i < this.$children.length; i++) {
        items.push(this.$children[i].options);
      }
      return items;
    },
  },
  mounted () {
    // Init and close so that zoom animation works on the first image.
    this.openGallery(0);
    this.gallery.close();

    // On mobile, set active class on current image.
    if (isMobile.any) {
      window.addEventListener('load', () => {
        let controller = new ScrollMagic.Controller();
        _.each(this.$el.querySelectorAll('.item'), (item) => {
          let scene = new ScrollMagic.Scene({triggerElement: item, duration: item.scrollHeight})
          scene.setClassToggle(item, 'active')
          scene.addTo(controller)
        })
      })
    }
  },
  methods: {
    openGallery (index) {
      var options = {
        galleryUID: this.id,
        history: false,
        index: index || 0,
        preload: [1, 3],
        closeOnScroll: false,
        closeOnVerticalDrag: false,
        showHideOpacity: true,
        getThumbBoundsFn: (index) => {
          let el = this.$children[index].$el;
          let pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          let rect = el.parentNode.getBoundingClientRect();
          return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
        }
      };
      this.gallery = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, options);
      this.gallery.init();
    }
  }
}
</script>



// WEBPACK FOOTER //
// assets/js/components/content/Gallery.vue